/**
 * Registry of console → docs deep links.
 *
 * Every in-app "Read the docs" / docs nav target should be registered in
 * docsLinks.registry.json so CI can verify the corresponding page exists under
 * frontend-docs/docs/.
 *
 * slug is the path after /docs/ (empty string = docs site home).
 */
import registryJson from './docsLinks.registry.json'

export type ConsoleDocsLink = {
  id: string
  slug: string
  title: string
}

export const CONSOLE_DOCS_LINKS = Object.freeze(registryJson) as Readonly<
  Record<keyof typeof registryJson, ConsoleDocsLink>
>

export function listConsoleDocsLinks(): ConsoleDocsLink[] {
  return Object.values(CONSOLE_DOCS_LINKS)
}
